import { CountryService, ResponseError } from '@ynap/api-utils';
import { timeout, delay } from '@ynap/promise-utils';
import { FETCH_ALL_PROVINCES_REQUEST, FETCH_ALL_PROVINCES_SUCCESS, FETCH_ALL_PROVINCES_ERROR } from '../constants/ActionTypes';

function fetchAllProvincesRequest() {
    return {
        type: FETCH_ALL_PROVINCES_REQUEST,
    };
}

function fetchAllProvincesSuccess(payload) {
    return {
        type: FETCH_ALL_PROVINCES_SUCCESS,
        payload,
    };
}

function fetchAllProvincesError() {
    return {
        type: FETCH_ALL_PROVINCES_ERROR,
    };
}

export default function fetchAllProvinces() {
    return (dispatch, getState) => {
        const { config } = getState();
        const { addressValidationService, global, head } = config;
        const { baseUrl } = addressValidationService || global.services.addressValidation;
        const { brandId } = global.application;
        const { clientRequest } = head || config;

        const request = CountryService.getAllProvinces({ baseUrl, brandId });
        dispatch(fetchAllProvincesRequest());

        //todo look at if this is shareable across state packages
        return delay(timeout(fetch(request), clientRequest.timeout), clientRequest.delay)
            .then((response) => {
                const { ok } = response;
                if (ok) {
                    return response
                        .json()
                        .then((json) => {
                            return dispatch(fetchAllProvincesSuccess(json.countries));
                        })
                        .catch((error) => fetchAllProvincesError(error));
                }

                throw new ResponseError(response);
            })
            .catch((error) => {
                dispatch(fetchAllProvincesError(error));
                throw error;
            });
    };
}
